import React from 'react';
import MainBanner from './home';
import Benifits from './benifits';
import Pricing from './pricing';
import About from './about';

const Landing = () => {
  return (
    <>
      <section id="home" className="flex items-center">
        <MainBanner />
      </section>
      <section>
        <Benifits />
      </section>
      <section>
        <About />
      </section>
      <section>
        <Pricing />
      </section>
    </>
  );
};

export default Landing;
